import React from "react";
import { PageProps } from "../types";

const Footer = ({ credits }: Pick<PageProps, "credits">) => (
  <footer>
    <p dangerouslySetInnerHTML={{ __html: credits }}></p>
  </footer>
);

export default Footer;
